var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "overview-items-wrapper" },
    _vm._l(_vm.nightlyRates, function (nRate, i) {
      return _c(
        "div",
        {
          key: nRate.date,
          staticClass: "overview-item",
          class: [{ "small-margin": i < _vm.nightlyRates.length - 1 }],
        },
        [
          _c("div", { staticClass: "item-label section-label" }, [
            _vm._v(
              "\n      " + _vm._s(_vm._f("dateFilter")(nRate.date)) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "item-value",
              class: [{ success: parseInt(nRate.price) === 0 }],
            },
            [
              _c("span", [
                parseInt(nRate.price) === 0
                  ? _c("span", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.tc("booking.complimentary"))),
                    ])
                  : _vm._e(),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.getDisplayPrice({ price: nRate.price })) +
                    "\n      "
                ),
              ]),
            ]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }